<template>
  <el-dialog
    title="Create new showroom"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main>
        <el-form>
          <el-form-item label="Name">
            <el-input
              v-model="form.name"
              @keydown.enter.native.prevent="submit"
            />
            <p
              v-for="error in errors.name"
              :key="error"
              class="text-xs text-danger"
            >
              {{ error }}
            </p>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="submit()">
          Create
        </el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
export default {
  props: {
    organizationId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      form: { name: '' },
      errors: {
        name: [],
      },
    }
  },
  methods: {
    open() {
      this.visible = true
      this.form.name = ''
    },

    async submit() {
      try {
        await this.$store.dispatch('eventList/create', {
          name: this.form.name,
          organizationId: this.organizationId,
        })
        this.$emit('created')
        this.visible = false
      } catch (e) {
        this.errors = e.response.data
        return false
      }
      return true
    },
  },
}
</script>
